<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='8'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <!--右侧开始-->
          <div class="cght_htmainrighttop">
            <div class="cght_htmainrighttopl">申购单</div>
            <div class="cght_htmainrighttopr">
              <div class="cght_htmainrighttoprl">
                <router-link :to="{path:'/Address'}">我的收货地址</router-link>
              </div>
            </div>
          </div>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <div class="cght_ddgltop">
              <ul class="cght_ddglnavula">
                <li><a href="javascript:;" :class="{cght_ddglnavulaxz:listQuery.filters.is_buy == null}" @click="changeState()">全部申购</a></li>
                <!-- <li><a href="javascript:;" :class="{cght_ddglnavulaxz:listQuery.orderType == 2}">待付款 <em>1</em></a></li> -->
                <li><a href="javascript:;" :class="{cght_ddglnavulaxz:listQuery.filters.is_buy == 0}" @click="changeState(0)">待采购<em></em></a></li>
                <li><a href="javascript:;" :class="{cght_ddglnavulaxz:listQuery.filters.is_buy == 1}" @click="changeState(1)">已采购 <em></em></a></li>
              </ul>
              <div class="cght_ddglright">
                <!-- <div class="cght_ddglrightl"><a href="__ROOT__/Member/ddhsz">我的订单回收站</a></div>选中cght_ddglrightlxz -->
                <div class="cght_ddglrightr"><div><em><input type="text" class="cght_inputtextsh" ddkeywords/></em><a href="javascript:;" ddsearch></a></div></div>
              </div>
            </div>
            <div class="cght_table_boxhie" v-loading="qyloading">
              <!-- 申购单 -->
              <table class="cght_ddtable" v-for="(item, index) in list" :key="index" width="990" cellspacing="0" cellpadding="0">
                <tr class="cght_ddtabletb">
                  <td colspan="6">
                    <div class="cght_ddtablesj">{{item.create_time}}</div>
                    <div class="cght_ddtableddh">订单号：<em>{{item.order_id}}</em></div>
                    <div class="cght_ddtablesl" style="width: 103px;">数量</div>
                    <div class="cght_ddtablesl" style="width: 170px;">价格</div>
                    <div class="cght_ddtablesc" @click="delPreOrder(item.order_id)"><i class="iconfont cght_scddqdshowtc">&#xe611;</i></div>
                    <!-- <div class="cght_ddtablesc myprint" @click="delPreOrder(item.order_id)">打印</div> -->
                    <div class="cght_ddtablesl" style="width: 250px;">规格</div>
                  </td>
                </tr>
                <div class="unfoContainer">
                  <div class="unfold" @click="changeBtn(item)" :class="item.unfoIsShow ? 'on' : ''">
                    <i class="el-icon el-icon-arrow-down"></i>
                  </div>
                   <ul :style="item.unfoIsShow ? 'height: 155px': 'height: 0;overflow: hidden'">
                    <li>
                      <div class="purchasing">单位名称：{{item.company_name}}</div>
                      <div class="purchasing">事业部：{{item.plant_name}}</div>
                    </li>
                    <li>
                      <div class="purchasing">申购人：{{item.premember_name}}</div>
                      <div class="purchasing" v-if="item.total_amount && item.total_amount >0 ">申购金额：{{item.total_amount}}</div>
                      <div class="purchasing" v-else>申购金额：询价</div>
                    </li>
                    <li>备注：{{item.remark}}</li>
                  </ul>
                </div>
                <tr v-for="(goods, i) in item.goods_list" :key="i">
                  <td width="465" class="cght_ddtablexxnrabox">
                    <div class="cght_ddtablexxnra">
                      <router-link :to="{path:'/GoodsDetail',query:{id:goods.goods_id}}">
                        <img v-real-img="goods.imgpath" src="../../assets/images/zwtp.jpg" :alt="goods.title" width="60" height="60" />
                      </router-link>
                    </div>
                    <div class="cght_ddtablexxnrb">
                      <h3><router-link :to="{path:'/GoodsDetail',query:{id:goods.goods_id}}" target="_blank">{{goods.title}}</router-link></h3>
                    </div>
                    <div class="cght_ddtablexxnrc" style="width:90px;">x{{goods.number}}</div>
                    <!--<div class="cght_ddtablexxnrd"><a href="javascript:;">退货</a></div>-->
                  </td>
                  <td rowspan="" width="80" class="cght_ddtableshrm">
                    <div class="cght_ddtableje4" v-if="goods.tax_price && goods.tax_price > 0">￥{{goods.tax_price}}</div>
                    <div class="cght_ddtableje4" v-else>询价</div>
                  </td>
                  <td rowspan="" width="110">
                    <div class="cght_ddtableje5" v-if="goods.tax_price*goods.number > 0">￥{{(goods.tax_price*goods.number).toFixed(2)}}</div>
                    <div class="cght_ddtableje5" v-else>询价</div>
                    <div class="cght_ddtableje4"><a>{{goods.plant_sku || goods.sku}}</a></div>
                  </td>
                  <td colspan="2">
                    <el-tag size="mini" style="margin-left:10px;" v-for="(ie,i) in goods.specParamList" :key="i">{{ie.param_name}}：{{ie.option_value}}</el-tag>
                  </td>
                  <td rowspan="" width="80" class="cght_ddtableshrm">
                    <span v-if="goods.is_buy">已采购</span>
                    <el-button class="action-item" v-else icon="el-icon-delete" size="mini" @click="delOrderGoods(goods)">删除</el-button>
                  </td>
                </tr>
              </table>
              <div class="cght_meiyoudingdansc" v-if="emptyShow && list.length==0">
                <div class="cght_meiyoudingdanscd">
                  <em>您还没有申购单~</em>
                  <!-- <router-link :to="{path:'/'}" class="cght_meiyoudingdanscda">去首页看看</router-link> -->
                </div>
              </div>
              <div class="cght_tjddbottomd" v-if="list.length > 0" style="margin-top:30px;">
                <a href="javascript:void(0);" class="cght_tjddbottomda" @click="create_preorder">生成采购单</a>
              </div>
              <!-- <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/order'

export default {
  name: 'PreOrderList',
  components: { Top, LeftNav, Bottom, Pagination },
  data () {
    return {
      unfoIsShow: false,
      api,
      qyloading: false,
      listQuery: {
        limit: 30,
        order: 'create_time',
        filters: {
        }
      },
      list: [],
      orderIdList: [],
      emptyShow: false
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.LoadData()
  },
  methods: {
    changeBtn (item) {
      item.unfoIsShow = !item.unfoIsShow
    },
    LoadData () {
      this.qyloading = true
      api.queryPreorder(this.listQuery).then(res => {
        let newlist = res.items
        newlist.forEach(element => {
          element.goods_list.forEach(response => {
            response.specParamList = JSON.parse(response.specParamList)
          })
          this.orderIdList.push(element.order_id)
          element.unfoIsShow = false
        })
        this.list = newlist
        this.qyloading = false
        this.emptyShow = true
      })
    },
    changeState (state) {
      if (state === undefined) {
        this.listQuery.filters = {}
      } else {
        this.listQuery.filters = {is_buy: state}
      }
      this.listQuery.page = 1
      this.LoadData()
    },
    delPreOrder (orderId) {
      this.$confirm('确定删除该申购单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delPreOrder({orderId: orderId}).then(res => {
          this.listQuery.page = 1
          this.LoadData()
        })
      }).catch(() => {})
    },
    delOrderGoods (goods) {
      this.$confirm('确定删除该申购产品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delOrderGoods({goods_id: goods.goods_id, order_id: goods.order_id}).then(res => {
          this.listQuery.page = 1
          this.LoadData()
        })
      }).catch(() => {})
    },
    create_preorder () {
      // 因为与购物车等页面共用ConfirmOrder页面，所以与跳转前清除购物车的store值
      localStorage.setItem('preorderList', JSON.stringify(this.orderIdList))
      localStorage.removeItem('cart_checkList')
      localStorage.removeItem('fastList')
      localStorage.removeItem('nowBuy_goods')
      this.$router.push({path: '/ConfirmOrder'})
    }
  }
}
</script>
<style scoped>
  .cght_ddtable{
    position: relative;
  }
  .cght_meiyoudingdansc{
    display: block;
  }
  .unfoContainer{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  .unfold{
    position: absolute;
    top: 40px;
    left: 51%;
    margin-left: -25px;
    width:50px;
    height:32px;
    text-align: center;
    line-height: 32px;
    z-index: 8;
    background: #ffffff;
    cursor: pointer;
    transition: all .3s;
    box-shadow: 0 3px 5px #9da0a5;
    border-radius: 0 0 6px 6px;
  }
  .unfold.on .el-icon{
    transform: rotate(180deg);
  }
  .unfold:hover .el-icon{
    color: #409EFF;
  }
  .unfoContainer ul{
    position: absolute;
    left: 0;
    top: 40px;
    width: 100%;
    padding: 0 20px;
    z-index: 7;
    transition: all .3s;
    box-sizing: border-box;
    line-height: 23px;
    background: #ffffff;
    box-shadow: 0 2px 5px #9da0a5;
    overflow: hidden;
  }
  .unfoContainer ul li:first-child{
    padding: 40px 0 0;
  }
  /* .unfoContainer ul li:last-child{
    padding: 0 0 20px;
  } */
  .unfoContainer ul li{
    display: inline-block;
    width: 100%;
  }
  .purchasing{
    float: left;
    width: 50%;
  }
  .myprint{
    border:1px solid #ccc;
    padding: 0;
    width: 45px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    border-radius: 5px;
    cursor:pointer;
    margin-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/view/member/preorder_list.vue